import { Star } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const ppcTestimonialsSection: ServiceSection = {
  type: SECTION_TYPES.PPC_TESTIMONIALS,
  content: {
    header: "What Your Neighbors Are Saying",
  },
  meta: {
    displayName: "Testimonials PPC",
    displayDescription: "Give your customers a reason to trust you.",
    displayIcon: Star,
  },
};

export default ppcTestimonialsSection;
